import { useTranslation } from "react-i18next";
import { Icon, Label, Popup } from "semantic-ui-react";

import "components/AppointmentNotes/AppointmentNotes.scss";
import { DATE_FORMATS_FNS } from "components/DatePicker";
import { APPOINTMENT_NOTE_TYPES } from "models";
import { formatDate } from "utils/dateHelperFunctions";

import type { AppointmentNote } from "models";

type AppointmentNotesProps = {
  carInShop: boolean;
  carOutOfShop: boolean;
  notes?: AppointmentNote[];
};

export const AppointmentNotes = ({ notes, carInShop, carOutOfShop }: AppointmentNotesProps) => {
  const { t } = useTranslation();

  const mainNote = notes?.find(n => n.appointment_note_type_id === APPOINTMENT_NOTE_TYPES.Main);
  const callCustomerNote = notes?.find(n => n.appointment_note_type_id === APPOINTMENT_NOTE_TYPES.CallCustomer);
  const noDriveNote = notes?.find(n => n.appointment_note_type_id === APPOINTMENT_NOTE_TYPES.NoDrive);

  return (
    <div className="AppointmentNotesIcons-wrapper">
      {mainNote && (
        <Popup
          wide
          basic
          content={
            <div className="AppointmentNotePopup">
              <div className="AppointmentNoteTitle">
                <Icon className="note sticky red" />
                <span>{t("v8_main_note", "Main Note")}</span>
              </div>
              <div className="AppointmentNoteDescription">
                {mainNote.updated_by
                  ? `${mainNote.updated_by.first_name} ${mainNote.updated_by.last_name} ${t("v8_updated_main_note", "updated Main Note")} `
                  : `${mainNote.created_by?.first_name} ${mainNote.created_by?.last_name} ${t("v8_added_main_note", "added Main Note")} `}
                {`${formatDate(mainNote.updated_on, DATE_FORMATS_FNS.dateMonthYearTime)}`}
              </div>
              <div className="AppointmentNoteContent">{mainNote.note}</div>
            </div>
          }
          trigger={
            <Label circular color="red">
              <Icon className="note sticky red" />
            </Label>
          }
        />
      )}

      {callCustomerNote && (
        <Popup
          wide
          basic
          content={
            <div className="AppointmentNotePopup">
              <div className="AppointmentNoteTitle">
                <Icon className="phone flip green" />
                <span>{t("v8_call_customer_note", "Call Customer Note")}</span>
              </div>
              <div className="AppointmentNoteDescription">
                {callCustomerNote.updated_by
                  ? `${callCustomerNote.updated_by.first_name} ${callCustomerNote.updated_by.last_name} ${t(
                      "v8_updated_call_customer_note",
                      "updated Call Customer Note"
                    )} `
                  : `${callCustomerNote.created_by?.first_name} ${callCustomerNote.created_by?.last_name} ${t("v8_added_call_customer_note", "added Call Customer Note")} `}
                {`${formatDate(callCustomerNote.updated_on, DATE_FORMATS_FNS.dateMonthYearTime)}`}
              </div>

              <div className="AppointmentNoteContent">
                <Label className="CallCustomerPhoneNr">{callCustomerNote.phone_nr}</Label>
                <div>{callCustomerNote.note}</div>
              </div>
            </div>
          }
          trigger={
            <Label circular color="green">
              <Icon className="phone flip green" />
            </Label>
          }
        />
      )}

      {noDriveNote && carInShop && !carOutOfShop && (
        <Popup
          wide
          basic
          content={
            <div className="AppointmentNotePopup">
              <div className="AppointmentNoteTitle">
                <Icon className="circle minus" style={{ color: "#FF0301" }} />
                <span>{t("v8_no_drive_note", "No Drive Note")}</span>
              </div>
              <div className="AppointmentNoteDescription">
                {noDriveNote.updated_by
                  ? `${noDriveNote.updated_by.first_name} ${noDriveNote.updated_by.last_name} ${t("v8_updated_no_drive_note", "updated No Drive Note")} `
                  : `${noDriveNote.created_by?.first_name} ${noDriveNote.created_by?.last_name} ${t("v8_added_no_drive_note", "added No Drive Note")} `}
                {`${formatDate(noDriveNote.updated_on, DATE_FORMATS_FNS.dateMonthYearTime)}`}
              </div>

              <div className="AppointmentNoteContent">{noDriveNote.note}</div>
            </div>
          }
          trigger={<Icon circular className="circle minus" style={{ color: "#FF0301" }} />}
        />
      )}
    </div>
  );
};
